import { stack } from '@/lib/portfolio';
import { cn } from '@/lib/utils';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';

export function Stack() {
  return (
    <section id="stack" className="relative scroll-mt-28 py-28 md:py-36">
      {/* Ambient glow */}
      <div className="absolute left-1/2 top-0 size-[30rem] -translate-x-1/2 rounded-full bg-pulsar/10 blur-[140px]" aria-hidden="true" />

      <div className="container relative">
        <SectionHeading
          eyebrow="Technical architecture"
          title={
            <>
              The toolbox,{' '}
              <span className="font-serif font-normal italic text-comet">lovingly overstocked.</span>
            </>
          }
          description="From Rust to RAG to nine different chains — pick a problem, there's a tool in here for it."
        />

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-6">
          {stack.map((category, i) => {
            const Icon = category.icon;
            return (
              <Reveal
                key={category.title}
                delay={0.06 * i}
                className={cn(category.wide ? 'lg:col-span-3' : 'lg:col-span-2')}
              >
                <div
                  className={cn(
                    'group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-card/60 p-6 backdrop-blur transition-all duration-300',
                    'hover:-translate-y-1 hover:border-white/25 md:p-8',
                    category.glow,
                  )}
                >
                  {/* Watermark icon */}
                  <Icon
                    className="pointer-events-none absolute -bottom-6 -right-6 size-32 text-white opacity-[0.04] transition-all duration-500 group-hover:rotate-6 group-hover:opacity-[0.08]"
                    aria-hidden="true"
                  />

                  <div className="flex items-center gap-4">
                    <span className="flex size-12 shrink-0 items-center justify-center rounded-2xl border border-white/10 bg-white/5 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                      <Icon className={cn('size-6', category.accent)} />
                    </span>
                    <div>
                      <h3 className="font-display text-lg font-semibold leading-tight">
                        {category.title}
                      </h3>
                      <p className="mt-0.5 font-serif italic text-muted-foreground">
                        {category.blurb}
                      </p>
                    </div>
                  </div>

                  <div className="mt-6 flex flex-wrap gap-2">
                    {category.items.map((item) => (
                      <span
                        key={item}
                        className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-muted-foreground transition-colors hover:border-white/30 hover:text-foreground"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
